<template lang="pug">
div(class="h-10")
    div(class="select h-full")
        select(
            v-model="selectedBrand"
            class="h-full"
        )
            option(value="") All Brands
            template(v-for="brand in brands")
                option(:value="brand") {{ brand }}

</template>

<script>
import SearchComponent from '@/components/search/component'

export default {
    name: 'BrandSelector',
    extends: SearchComponent,
    data() {
        return {
            brands: [],
            selectedBrand: '',
        }
    },
    watch: {
        '$route.query.brand'(newVal) {
            this.setBrand(newVal)
        },
        selectedBrand(newVal) {
            // set brand refinement values
            this.$searchContext.indexes.forEach((index) => {
                index.clearRefinements()
                // This includes check makes sure that the brand selected is a valid brand
                if (newVal && this.brands.includes(newVal)) {
                    index.addRefinements('brands.brand', newVal)

                    let preferredBrandsFacet = 'preferredBrands'
                    if (index.key === 'brand') preferredBrandsFacet = `NOT ${preferredBrandsFacet}`
                    index.addRefinements(preferredBrandsFacet, newVal)
                }
            })

            // trigger new search
            this.$searchContext.search()

            // Update page to new sort
            this.$push.to({ query: { brand: newVal || undefined } })
        },
    },
    async mounted() {
        await this.getBrands()
        if (this.$route.query?.brand) this.setBrand(this.$route.query.brand)
    },
    methods: {
        async getBrands() {
            try {
                // this is using a private method we use internally that gets the results but doesn't set the state.
                const { refinements } = await this.$search.dealerLocatorBrands._search()

                // Get brand facet from search
                const brandFacetValues = refinements['brands.brand']

                // If we don't have any then return
                if (!brandFacetValues) return

                // Set brands equal to the values
                this.brands = brandFacetValues.map(({ value }) => value)
            } catch (error) {
                console.log('Unable to get brand facets')
            }
        },
        setBrand(brand) {
            if (this.brands.includes(brand))
                // This will make sure the selected brand
                this.selectedBrand = brand
        },
    },
}
</script>
